/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, takeLatest, put } from "redux-saga/effects";
import { newRequest } from "../../../../api/token";
//import { customNotify } from "../../../../components/UI/ToastNotify";
import { getToken, getWrapperToken, isGlobalApolloError } from "../../../../utils/helpers/auth";
import {
  eurailTicketSearchAction,
  getEurailTicketListAction,
  getEurailTicketHSID,
  eurailTicketPreBookAction,
  eurailTicketCheckoutAction,
  eurailTicketStationListAction,
  eurailConfigKeyAction,
  getAgentEurailBookingDetailsAction,
  getEurailBookingDetailsAction,
  eurailTicketStationToListAction,
  eurailSegmentChargesAction,
} from "../../../actions/Dashboard/eurailTicketActions";
import {
  EURAIL_TICKET_SEARCH,
  GET_EURAIL_TICKET_LIST,
  EURAIL_TICKET_PRE_BOOK,
  EURAIL_TICKET_CHECKOUT,
  EURAIL_STATION_LIST,
  EURAIL_CONFIG_KEY,
  GET_EURAIL_BOOKING_DETAILS,
  AGENT_GET_EURAIL_BOOKING_DETAILS,
  EURAIL_STATION_TO_LIST,
  EURAIL_SEGMENT_CHARGES,
} from "../../../actionTypes/Dashboard/eurailTicketActionTypes";
import {
  AGENT_EURAIL_BOOKING_DETAILS,
  ET_CHECKOUT,
  ET_PRE_BOOK,
  ET_SEARCH,
  ET_SEARCH_RESULT,
  ET_STATION_LIST,
  ET_STATION_TO_LIST,
  EURAIL_BOOKING_DETAILS,
  EURAIL_CONFIG_KEY_QUERY,
  EURAIL_SEGMENT_CHARGES_QUERY,
} from "../../../gqlQueries/Dashboard/eurailQuery";
import { getNotificationMessage } from "../../../actions/localStorageActions";
import { UIMessage } from "../../../../components/UI/UIMessage";
import { getLanguageCode } from "../../../../locales/getlanguagecode";
import engLang from "../../../../locales/languages/Dashboard/DashboardEng.json";
import spanLang from "../../../../locales/languages/Dashboard/DashboardSpan.json";
import { decryptAPIData, encryptAPIData } from "../../../../utils/helpers/common";
function* eurailTicketStationList(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: action?.payload?.input,
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: ET_STATION_LIST,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      apiData?.data?.eurailStations?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      const stationData = apiData?.data?.eurailStations?.responseData?.data?.suggestions;
      yield put(
        eurailTicketStationListAction.FULLFILLED({
          data: stationData,
          status: 200,
        })
      );
      action?.payload?.setError && action?.payload?.setError(true);
    } else {
      action?.payload?.setError && action?.payload?.setError(false);
      const message = {
        isOpen: true,
        mainHeader: getLanguageCode(engLang, spanLang)?.promtsMessages?.wentwrong,
        subHeader: "",
        message: getLanguageCode(engLang, spanLang)?.promtsMessages?.ListnotAvailable,
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(eurailTicketStationListAction.REJECTED());
      action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.promtsMessages?.wentwrong,
      closeIcon: true,
      onClose: () => action?.payload?.setLoading(false),
    });
    yield put(eurailTicketStationListAction.REJECTED());
    action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
  }
}

function* eurailTicketStationToList(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: action?.payload?.input,
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: ET_STATION_TO_LIST,
      clientType: "BE",
      data: customHeaders,
    });
    if (
      apiData?.data?.eurailStations?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      const stationData = apiData?.data?.eurailStations?.responseData?.data?.suggestions;
      yield put(
        eurailTicketStationToListAction.FULLFILLED({
          data: stationData,
          status: 200,
        })
      );
      action?.payload?.setError && action?.payload?.setError(true);
    } else {
      action?.payload?.setError && action?.payload?.setError(false);
      const message = {
        isOpen: true,
        mainHeader: getLanguageCode(engLang, spanLang)?.promtsMessages?.wentwrong,
        subHeader: "",
        message: getLanguageCode(engLang, spanLang)?.promtsMessages?.ListnotAvailable,
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(eurailTicketStationListAction.REJECTED());
      action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: "Something went wrong, Unable to fetch Station List.",
      closeIcon: true,
      onClose: () => action?.payload?.setLoading(false),
    });
    yield put(eurailTicketStationToListAction.REJECTED());
    action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
  }
}

function* eurailTicketSearch(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.apiPayload),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ET_SEARCH,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    if (
      apiData?.data?.eurailTicketSearch?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.eurailTicketSearch?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      const searchKeyValue = apiData?.data?.eurailTicketSearch?.responseData;
      if (searchKeyValue?.data?.searchKey) {
        yield put(
          eurailTicketSearchAction.FULLFILLED({
            data: searchKeyValue,
            status: 200,
          })
        );
      } else {
        const message = {
          isOpen: true,
          mainHeader: getLanguageCode(engLang, spanLang)?.promtsMessages?.No_Result_Found,
          subHeader: "",
          message: "",
          subReq: false,
        };
        yield put(getNotificationMessage(message));
        yield put(eurailTicketSearchAction.REJECTED());
      }
    } else {
      const message = {
        isOpen: true,
        mainHeader: getLanguageCode(engLang, spanLang)?.promtsMessages?.wentwrong,
        subHeader: "",
        message: "Search Key is not available",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(eurailTicketSearchAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.promtsMessages?.timeoutmessage,
      closeIcon: true,
    });
    yield put(eurailTicketSearchAction.REJECTED());
  }
}

function* getEurailTicketList(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: action?.payload?.ts,
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: ET_SEARCH_RESULT,
      clientType: "BE",
      data: customHeaders,
    });
    // Do not setLoader(false) before FULLFILLED — that paints empty "No records"
    // for a frame before the results page processes the list.
    if (
      apiData?.data?.eurailTicketList?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.eurailTicketList?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      yield put(
        getEurailTicketListAction.FULLFILLED({
          data: apiData?.data?.eurailTicketList?.responseData,
          status: 200,
        })
      );
      yield put(
        getEurailTicketHSID.FULLFILLED({
          data: apiData?.data?.eurailTicketList?.responseData?.data?.search_id,
        })
      );
      // Loader cleared by results page after list is applied
    } else if (
      apiData?.data?.eurailTicketList?.responseData?.search_id[0] !== ""
    ) {
      // yield put(getEurailTicketListAction.REJECTED());
      yield put(
        getEurailTicketListAction.FULLFILLED({
          data: apiData?.data?.eurailTicketList?.responseData,
          status: 200,
        })
      );
      yield put(
        getEurailTicketHSID.FULLFILLED({
          data: apiData?.data?.eurailTicketList?.responseData?.search_id[0],
        })
      );
      action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
      action?.payload?.setLoader && action?.payload?.setLoader(false);
    } else {
      yield put(getEurailTicketListAction.REJECTED());
      yield put(getEurailTicketHSID.REJECTED());
      action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
      action?.payload?.setLoader && action?.payload?.setLoader(false);
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.promtsMessages?.timeoutmessage,
      closeIcon: true,
    });
    yield put(getEurailTicketListAction.REJECTED());
    action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
  }
}

function* eurailTicketPreBook(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.apiPayload),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ET_PRE_BOOK,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader(false);
    if (
      apiData?.data?.eurailTicketPrebook?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.eurailTicketPrebook?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      yield put(
        eurailTicketPreBookAction.FULLFILLED({
          data: apiData?.data?.eurailTicketPrebook?.responseData,
          status: 200,
        })
      );
    } else {
      const message = {
        isOpen: true,
        mainHeader: "The response from Eurail taking more time than expected, please try after some time.",
        subHeader: "",
        message: "",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(eurailTicketPreBookAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader(false);
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.promtsMessages?.timeoutmessage,
      closeIcon: true,
    });
    yield put(eurailTicketPreBookAction.REJECTED());
  }
}

function* eurailTicketCheckout(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.apiPayload),
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ET_CHECKOUT,
      clientType: "BE",
      data: customHeaders,
    });
    action?.payload?.setLoader(false);
    if (
      apiData?.data?.eurailTicketCheckout?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.eurailTicketCheckout?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      action?.payload?.getCheckoutDetails?.(apiData?.data?.eurailTicketCheckout?.responseData?.data?.status?.toLowerCase());
      yield put(
        eurailTicketCheckoutAction.FULLFILLED({
          data: apiData?.data?.eurailTicketCheckout?.responseData,
          status: 200,
        })
      );
    } else {
      if (action?.payload?.callingFrom == "online") {
        setTimeout(() => {
          window.location.href = "/";
        }, 5000);
      }
      action?.payload?.getCheckoutDetails?.("pending");
      yield put(eurailTicketCheckoutAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setLoader(false);
    action?.payload?.getCheckoutDetails?.("pending");
    if (action?.payload?.callingFrom == "online") {
      setTimeout(() => {
        window.location.href = "/";
      }, 5000);
    }
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.promtsMessages?.timeoutmessage,
      closeIcon: true,
    });
    yield put(eurailTicketCheckoutAction.REJECTED());
  }
}

function* eurailConfigKey(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: action?.payload,
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: EURAIL_CONFIG_KEY_QUERY,
      clientType: "MO",
      data: customHeaders,
    });
    if (
      apiData?.data?.configValueByKey?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      yield put(
        eurailConfigKeyAction.FULLFILLED({
          data: apiData?.data?.configValueByKey?.responseData,
          status: 200,
        })
      );
    } else {
      yield put(eurailConfigKeyAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    yield put(eurailConfigKeyAction.REJECTED());
  }
}

function* getEurailBookingsDetails(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    bid: action?.payload?.bid,
  };
  try {
    const BookingDataByBid = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: EURAIL_BOOKING_DETAILS,
      data: customHeaders,
      clientType: "BE",
    });
    action?.payload?.setBookingLoader(false);
    if (
      BookingDataByBid?.data?.eurailBookingDetailsByBid?.successTypeCode?.toLowerCase() ==
      "success" &&
      BookingDataByBid?.data?.eurailBookingDetailsByBid?.responseData
    ) {
      yield put(
        getEurailBookingDetailsAction.FULLFILLED(
          BookingDataByBid?.data?.eurailBookingDetailsByBid?.responseData
        )
      );
    } else {
      yield put(getEurailBookingDetailsAction.FULLFILLED(""));
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setBookingLoader(false);
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Unable to fetch Booking Details",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(getEurailBookingDetailsAction.REJECTED());
  }
}

function* getAgentEurailBookingsDetails(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    bid: action?.payload?.bid,
    agent_id: action?.payload?.agent_id,
  };
  try {
    const BookingDataByBid = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: AGENT_EURAIL_BOOKING_DETAILS,
      data: customHeaders,
      clientType: "MO",
    });
    action?.payload?.setBookingLoader(false);
    if (
      BookingDataByBid?.data?.agentEurailBookingDetails?.successTypeCode?.toLowerCase() ==
      "success" &&
      BookingDataByBid?.data?.agentEurailBookingDetails?.responseData
    ) {
      yield put(
        getAgentEurailBookingDetailsAction.FULLFILLED(
          BookingDataByBid?.data?.agentEurailBookingDetails?.responseData
        )
      );
    } else {
      yield put(getAgentEurailBookingDetailsAction.FULLFILLED(""));
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    action?.payload?.setBookingLoader(false);
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Unable to fetch Booking Details",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(getAgentEurailBookingDetailsAction.REJECTED());
  }
}

function* eurailSegmentChargesSaga(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: encryptAPIData(JSON.stringify(action?.payload?.apiPayload)),
  };
  action?.payload?.setLoading?.(true);

  try {
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: EURAIL_SEGMENT_CHARGES_QUERY,
      data: customHeaders,
      clientType: "MO",
    });

    if (queryResp?.data?.eurailSegmentCharges?.successTypeCode === 'SUCCESS') {

      const responseData = JSON.parse(decryptAPIData(
        queryResp.data.eurailSegmentCharges.responseData
      ));

      yield put(
        eurailSegmentChargesAction.FULLFILLED(responseData)
      );

    } else {
      const message = {
        isOpen: true,
        mainHeader: "Failed to connect",
        subHeader: "",
        message: "Unable to fetch Segment Charges, Please try again.",
        subReq: false,
      };

      yield put(getNotificationMessage(message));
      yield put(eurailSegmentChargesAction.FULLFILLED(null));
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;

    action?.payload?.setLoading?.(false);

    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Unable to fetch Segment Charges, Please try again.",
      subReq: false,
    };

    yield put(getNotificationMessage(message));
    yield put(eurailSegmentChargesAction.REJECTED());
  } finally {
    action?.payload?.setLoading?.(false);
  }
}
export function* watcherEurailTicket() {
  yield takeLatest(EURAIL_STATION_LIST.STARTED, eurailTicketStationList);
  yield takeLatest(EURAIL_STATION_TO_LIST.STARTED, eurailTicketStationToList);
  yield takeLatest(EURAIL_TICKET_SEARCH.STARTED, eurailTicketSearch);
  yield takeLatest(GET_EURAIL_TICKET_LIST.STARTED, getEurailTicketList);
  yield takeLatest(EURAIL_TICKET_PRE_BOOK.STARTED, eurailTicketPreBook);
  yield takeLatest(EURAIL_TICKET_CHECKOUT.STARTED, eurailTicketCheckout);
  yield takeLatest(EURAIL_CONFIG_KEY.STARTED, eurailConfigKey);
  yield takeLatest(
    GET_EURAIL_BOOKING_DETAILS.STARTED,
    getEurailBookingsDetails
  );
  yield takeLatest(
    AGENT_GET_EURAIL_BOOKING_DETAILS.STARTED,
    getAgentEurailBookingsDetails
  );
  yield takeLatest(
    EURAIL_SEGMENT_CHARGES.STARTED,
    eurailSegmentChargesSaga
  );
}

export const sagas = [watcherEurailTicket];
